module.exports = __webpack_public_path__ + "img/secondaire.126bb298.png";